/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const reviewerHeatmapCellSchema = z.object({
  dow: z.number().int().min(0).max(6),
  hour: z.number().int().min(0).max(23),
  count: z.number(),
});

export const getReviewerPerformanceHeatmapV1DataSchema = z.object({
  userId: z.string(),
  days: z.number(),
  cells: z.array(reviewerHeatmapCellSchema),
});

export type IReviewerHeatmapCell = z.infer<typeof reviewerHeatmapCellSchema>;
export type IGetReviewerPerformanceHeatmapV1Data = z.infer<
  typeof getReviewerPerformanceHeatmapV1DataSchema
>;

export const getReviewerPerformanceHeatmapV1ResponseSchema = createApiResponseSchema(
  getReviewerPerformanceHeatmapV1DataSchema,
) as z.ZodSchema<IAPI<IGetReviewerPerformanceHeatmapV1Data>>;

export type IGetReviewerPerformanceHeatmapV1Response = IAPI<IGetReviewerPerformanceHeatmapV1Data>;
